import React, { useEffect, useState } from "react";
import { Select, Space, Spin, Typography } from "antd";
import axiosInstance from "../../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../../variables/constants";

const { Text } = Typography;

const AvenantAgencySelector = ({ organismeCode, defaultAgence }) => {
    const [agences, setAgences] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState(
        defaultAgence?.codeAgence || defaultAgence?.codeId || null
    );
    const [loading, setLoading] = useState(false);

    const isSiegeUser =
        LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null;

    useEffect(() => {
        console.log("AvenantAgencySelector mounted or organismeCode changed", { organismeCode, defaultAgence });
        if (!isSiegeUser) return;

        const endpoint = organismeCode
            ? `/api/agence/organisme/code/${organismeCode}`
            : `/api/agence/assurances`;

        setLoading(true);
        axiosInstance
            .get(endpoint)
            .then((res) => {
                const agencies = Array.isArray(res.data) ? res.data : [];
                setAgences(agencies);
                console.log("Defaulting selected agency to first in list ", agencies[0]);
                if (!selectedAgence && agencies.length) {
                    console.log("Defaulting selected agency to first in list ", agencies[0]);
                    setSelectedAgence(agencies[0]?.codeAgence || agencies[0]?.codeId || null);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }, [organismeCode, isSiegeUser]);

    if (!isSiegeUser) return null;

    return (
        <div style={{ marginBottom: 16 }}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
                <Text strong>Agence ciblée pour cet avenant</Text>
                <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Sélectionnez l'agence"
                    value={selectedAgence || undefined}
                    onChange={setSelectedAgence}
                    loading={loading}
                    optionFilterProp="label"
                    notFoundContent={loading ? <Spin size="small" /> : null}
                    options={agences.map((ag) => ({
                        label: `${ag.nom} (${ag.codeAgence || ag.codeId || "?"})`,
                        value: ag.codeAgence || ag.codeId
                    }))}
                />
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Info : le choix d'agence reste local au siège et n'est pas transmis au backend.
                </Text>
            </Space>
        </div>
    );
};

export default AvenantAgencySelector;
